import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from 'lodash';

import withUpload from "../../hoc/withUpload";
import {fetchCurrentUser, updateCurrentUser} from "../../../creators/currentUser";

import {Button} from "../Button";

class UploaderAC extends React.Component {
    constructor(props){
        super(props);
        this.id = _.random(0, 99999);
        this.state = {
            errorMessage: '',
            preview: this.props.preview,
            uploadedMedia: {},
            isUploaded: false,
        };
        this.type = {
            avatar : "un avatar",
            photo : "une photo"
        };
        this.typeText = {
            avatar : <span className={"mt-16"}>Les gros plans et images trop hard sont interdits sur les avatars.</span>,
            photo : "",
            cover : <span className={"mt-16"}>Gros plans ou images de scènes sexuelles HARD interdites.<br /> RECOMMANDATION: 828x 315 pixels pour éviter la pixellisation de votre couverture</span>
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.preview !== this.props.preview){
            this.setState({preview: this.props.preview});
            this.props.uploadFile();
        }
    }

    onUploadError({response}){
        this.props.reset();
        let message = '';
        switch (response.statusCode) {
            case 413:
                message = `Fichier trop lourd, maximum accepté : ${response.errors.maxFileSizeStr}`;
                break;
            case 415:
                message = `Fichier non accepté, sont acceptés : ${response.errors.allowedTypes.join(', ')}`;
                break;
            case null:
                message = ``;
                break;
            default :
                message = 'Envoi du fichier impossible, erreur système inconnue';
                break;
        }
        this.setState({errorMessage: message, preview: ""})
    }

    onUploadSuccess(data){
        if(data){
            this.setState({uploadedMedia: data, isUploaded: true, preview : data.preview});
        }

    }

    handleSubmit(){
        this.props.reset();
        this.props.handleClose();
        // console.log(this.state.uploadedMedia);
        if(this.props.type === "avatar"){
            if(typeof this.props.handleData === "function"){
                this.props.handleData(this.state.uploadedMedia);
            }
            this.props.updateCurrentUser({
                profile : {
                    avatarId: this.state.uploadedMedia._id
                }
            });
        }
        else if(this.props.type === "photo"){
            this.props.updateCurrentUser({
                profile : {
                    photoCertifiedId: this.state.uploadedMedia._id
                }
            });
        }
        else {
            this.props.updateCurrentUser({
                profile : {
                    coverId: this.state.uploadedMedia._id
                }
            });
        }
    }

    render(){
        return <div id={"uploads"} className={"modal-container"}>
            <div className={"modal-topline"}>
                {`Télécharger ${this.type[this.props.type] || "une photo de couverture"}`}
            </div>
            <div className={"modal-body"}>
                {this.state.preview &&
                    <div className={"img-preview-container"}>
                        <img alt={""} className={`img-preview`} src={this.state.preview} />
                    </div>
                }
                <input type="file"
                       id={this.id}
                       key={this.props.loadedFile.name}
                       style={{display:'none'}}
                       accept="image/jpeg, image/png"
                       disabled={this.props.uploading}
                       onChange={this.props.loadFile.bind(this)}/>

                <label htmlFor={this.id} className={"upload-input-btn"}>
                    <div className="btn white"
                        style={{background: `linear-gradient(to right,#51a9fd ${this.props.uploadProgress.percentCompleted}%,#1F7DEC ${this.props.uploadProgress.percentCompleted}%)`}}
                    >
                        {this.props.uploading ? (
                            `Envoi... ${Math.round(this.props.uploadProgress.eta / 1000)}s (${this.props.uploadProgress.kos}ko/s)`
                        ) : (
                            _.truncate(this.props.loadedFile.name, {length:this.props.nameLength || 25}) || 'Choisissez un fichier'
                        )}
                    </div>
                </label>
                {this.typeText[this.props.type] !== undefined ? this.typeText[this.props.type] : this.typeText['cover']}
            </div>
            <div className={"modal-baseline"}>
                {this.state.errorMessage && <span className={"warning upload-error-message"}>{this.state.errorMessage}</span>}
                {!this.props.uploading &&
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=>this.props.handleClose()}
                            content={"Fermer"}/>
                }
                {this.props.loadedFile.name && (
                    this.props.uploading &&
                        <Button btnStyle={"cancel-reverse"}
                                size={"small"}
                                onClick={()=>this.props.reset()}
                                content={"Annuler"}/>
                )}
                {this.state.isUploaded && (
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            onClick={()=>this.handleSubmit()}
                            content={"Enregistrer"}/>
                )}
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateCurrentUser,

    fetchCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withUpload(UploaderAC));